<template>
  <div class="layout">
    <Layout class="layout-main">
      <Header :style="{ position: 'fixed', width: '100%', zIndex: 5 }">
        <u-header
          @on-menu-click="menuClick"
          @on-menu-outside-click="menuOutsideClick"
        >
        </u-header>
      </Header>
      <Content>
        <!--<transition>-->
          <!--<keep-alive>-->
            <router-view></router-view>
          <!--</keep-alive>-->
        <!--</transition>-->
      </Content>
    </Layout>
    <transition name="sider">
      <keep-alive>
        <u-sider
          ref="side-menu"
          :active-name="$route.name"
          v-if="show"
          :menu-list="menuList"
        ></u-sider>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
//布局组件在vue-router中引入，无法共享，所以样式要单独引入
import "@/styles/component/main.less";
import uSider from "./side-menu";
import uHeader from "./header";
import { mapMutations } from "vuex";

export default {
  name: "index",
  mounted() {
    this.setBreadCrumb(this.$route);
  },
  data() {
    return {
      siderWidth: 120,
      show: false
    };
  },
  methods: {
    ...mapMutations([
      "setBreadCrumb"
    ]),
    menuOutsideClick() {
      if (!this.show) {
        return;
      }
      this.show = false;
    },
    menuClick() {
      this.show = !this.show;
    }
  },
  computed: {
    menuList() {
      return this.$store.getters.menuList;
    }
  },
  components: {
    uSider,
    uHeader
  },
  watch: {
    '$route'(newRoute) {
      this.setBreadCrumb(newRoute);
    }
  }
};
</script>
